import { render, staticRenderFns } from "./PreOrderRequest.vue?vue&type=template&id=6b958a1b&"
import script from "./PreOrderRequest.vue?vue&type=script&lang=js&"
export * from "./PreOrderRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports